<template>
    <div class="content">
        <h4 class="content_msg">{{this.msg}}</h4>

        <b-button variant="primary" @click="useESS">{{$t("iAMSmartContinue")}}</b-button>
    </div>
</template>

<script>
  export default {
    name: "afterLinkedIAmSmart",
    props: {
      exist: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        msg: '',
      }
    },
    created() {
        if (this.exist) {
          if (this.$i18n.locale === "zh_cn") {
             this.msg = '你是我们现有用户，已成功连接现有帐户，请登入';
          } else if (this.$i18n.locale === "zh_hk") {
             this.msg = '你是我們現有用戶，已成功連接現有帳戶，請登入';
          } else {
            this.msg = 'The registration has successfully linked with your existing account,please log in';
          }          
        } else {
          if (this.$i18n.locale === "zh_cn") {
             this.msg = '已经为你开设帐户,请登入';
          } else if (this.$i18n.locale === "zh_hk") {
             this.msg = '已經為你開設帳戶,請登入';
          } else {
            this.msg = 'Account created, please log in';
          }            
        }
    },
    methods: {
      useESS() {
        this.$emit('useESS');
      }
    }
  };
</script>

<style lang="scss" scoped>
.content {
    text-align: center;
    padding: 20px;
    .content_msg {
        margin-bottom: 30px;
    }
}
</style>

<i18n src="@/locales/iamsmart.linked.json"></i18n>